module.exports = __webpack_public_path__ + "static-portal/img/30.3bfaf5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/30.jpg
// module id = Hd+0
// module chunks = 4